// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3qKUk","select":"Header_select__3KI7s","clinic":"Header_clinic__2q0ea"};